import type { Card } from "./types";

export const TWISTERS: Card[] = [
  {
    "id": "seashells",
    "kind": "twister",
    "lang": "en",
    "text": "She sells seashells by the seashore.",
    "phonemes": [
      "S",
      "SH"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    }
  },
  {
    "id": "lorry",
    "kind": "twister",
    "lang": "en",
    "text": "Red lorry, yellow lorry.",
    "phonemes": [
      "R",
      "L"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    }
  },
  {
    "id": "buggy",
    "kind": "twister",
    "lang": "en",
    "text": "A big baby buggy with rubber buggy bumpers.",
    "phonemes": [
      "B"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    }
  },
  {
    "id": "fish",
    "kind": "twister",
    "lang": "en",
    "text": "Four fine fresh fish for you.",
    "phonemes": [
      "F"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    }
  },
  {
    "id": "icecream",
    "kind": "twister",
    "lang": "en",
    "text": "I scream, you scream, we all scream for ice cream.",
    "phonemes": [
      "S",
      "K",
      "R"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    }
  },
  {
    "id": "redleather",
    "kind": "twister",
    "lang": "en",
    "text": "Red leather, yellow leather.",
    "phonemes": [
      "R",
      "L"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "tip": "The actor's warm-up standard — loop it without slowing down."
  },
  {
    "id": "fuzzy",
    "kind": "twister",
    "lang": "en",
    "text": "Fuzzy Wuzzy was a bear. Fuzzy Wuzzy had no hair. Fuzzy Wuzzy wasn't fuzzy, was he?",
    "phonemes": [
      "Z",
      "W"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    }
  },
  {
    "id": "nurses",
    "kind": "twister",
    "lang": "en",
    "text": "Nine nice night nurses nursing nicely.",
    "phonemes": [
      "N"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    }
  },
  {
    "id": "copper",
    "kind": "twister",
    "lang": "en",
    "text": "A proper copper coffee pot.",
    "phonemes": [
      "P",
      "K"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    }
  },
  {
    "id": "snails",
    "kind": "twister",
    "lang": "en",
    "text": "Six slippery snails slid slowly seaward.",
    "phonemes": [
      "S",
      "L"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    }
  },
  {
    "id": "wales",
    "kind": "twister",
    "lang": "en",
    "text": "Wayne went to Wales to watch walruses.",
    "phonemes": [
      "W"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    }
  },
  {
    "id": "kitchen",
    "kind": "twister",
    "lang": "en",
    "text": "I saw a kitten eating chicken in the kitchen.",
    "phonemes": [
      "K",
      "CH"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    }
  },
  {
    "id": "piper",
    "kind": "twister",
    "lang": "en",
    "text": "Peter Piper picked a peck of pickled peppers.",
    "phonemes": [
      "P"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "woodchuck",
    "kind": "twister",
    "lang": "en",
    "text": "How much wood would a woodchuck chuck if a woodchuck could chuck wood?",
    "phonemes": [
      "W",
      "CH"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "oyster",
    "kind": "twister",
    "lang": "en",
    "text": "A noisy noise annoys an oyster.",
    "phonemes": [
      "N",
      "OY"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "rascal",
    "kind": "twister",
    "lang": "en",
    "text": "Round and round the rugged rocks the ragged rascal ran.",
    "phonemes": [
      "R"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "botter",
    "kind": "twister",
    "lang": "en",
    "text": "Betty Botter bought some butter, but she said the butter's bitter.",
    "phonemes": [
      "B",
      "T"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "lucky",
    "kind": "twister",
    "lang": "en",
    "text": "Luke Luck likes lakes. Luke's duck licks lakes.",
    "phonemes": [
      "L",
      "K"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "toyboat",
    "kind": "twister",
    "lang": "en",
    "text": "Toy boat. Toy boat. Toy boat. Toy boat. Toy boat.",
    "phonemes": [
      "T",
      "OY"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "tip": "Two words. Five reps. Harder than it has any right to be."
  },
  {
    "id": "blackbug",
    "kind": "twister",
    "lang": "en",
    "text": "The big black bug bit the big black bear, but the big black bear bit the big black bug back.",
    "phonemes": [
      "B"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "elephants",
    "kind": "twister",
    "lang": "en",
    "text": "Eleven benevolent elephants. Eleven benevolent elephants. Eleven benevolent elephants.",
    "phonemes": [
      "L",
      "V"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "chews",
    "kind": "twister",
    "lang": "en",
    "text": "If a dog chews shoes, whose shoes does he choose?",
    "phonemes": [
      "CH",
      "SH"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "clam",
    "kind": "twister",
    "lang": "en",
    "text": "How can a clam cram in a clean cream can?",
    "phonemes": [
      "K",
      "R"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "twins",
    "kind": "twister",
    "lang": "en",
    "text": "Twelve twins twirled twelve twigs.",
    "phonemes": [
      "T",
      "W"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "thinkers",
    "kind": "twister",
    "lang": "en",
    "text": "Three thin thinkers thinking thick thoughtful thoughts.",
    "phonemes": [
      "TH"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "cheetah",
    "kind": "twister",
    "lang": "en",
    "text": "Chester Cheetah chews a chunk of cheap cheddar cheese.",
    "phonemes": [
      "CH"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "papacoffee",
    "kind": "twister",
    "lang": "en",
    "text": "Give papa a cup of proper coffee in a copper coffee cup.",
    "phonemes": [
      "P",
      "K"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "freethrows",
    "kind": "twister",
    "lang": "en",
    "text": "He threw three free throws. He threw three free throws. He threw three free throws.",
    "phonemes": [
      "TH",
      "F",
      "R"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "goodblood",
    "kind": "twister",
    "lang": "en",
    "text": "Good blood, bad blood. Good blood, bad blood. Good blood, bad blood.",
    "phonemes": [
      "B",
      "L",
      "D"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "selfish",
    "kind": "twister",
    "lang": "en",
    "text": "Selfish shellfish. Selfish shellfish. Selfish shellfish. Selfish shellfish.",
    "phonemes": [
      "S",
      "SH"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    }
  },
  {
    "id": "sheik",
    "kind": "twister",
    "lang": "en",
    "text": "The sixth sheik's sixth sheep's sick.",
    "phonemes": [
      "S",
      "TH"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "tip": "Once the Guinness World Record for hardest tongue twister."
  },
  {
    "id": "menagerie",
    "kind": "twister",
    "lang": "en",
    "text": "Imagine an imaginary menagerie manager imagining managing an imaginary menagerie.",
    "phonemes": [
      "M",
      "N"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    }
  },
  {
    "id": "padkid",
    "kind": "twister",
    "lang": "en",
    "text": "Pad kid poured curd pulled cod.",
    "phonemes": [
      "P",
      "K"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "tip": "MIT researchers call this the hardest twister ever tested."
  },
  {
    "id": "wristwatch",
    "kind": "twister",
    "lang": "en",
    "text": "Irish wristwatch, Swiss wristwatch.",
    "phonemes": [
      "R",
      "S"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    }
  },
  {
    "id": "seething",
    "kind": "twister",
    "lang": "en",
    "text": "The seething sea ceaseth and thus the seething sea sufficeth us.",
    "phonemes": [
      "S",
      "TH"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    }
  },
  {
    "id": "unique",
    "kind": "twister",
    "lang": "en",
    "text": "Unique New York. Unique New York. You know you need unique New York.",
    "phonemes": [
      "N",
      "Y"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "tip": "Broadway's favorite pre-show warm-up."
  },
  {
    "id": "truly",
    "kind": "twister",
    "lang": "en",
    "text": "Truly rural. Truly rural. Truly rural. Truly rural.",
    "phonemes": [
      "R",
      "L"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    }
  },
  {
    "id": "peggy",
    "kind": "twister",
    "lang": "en",
    "text": "Peggy Babcock. Peggy Babcock. Peggy Babcock. Peggy Babcock. Peggy Babcock.",
    "phonemes": [
      "P",
      "B",
      "K"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "tip": "Ten letters, five reps — a legendary jaw-breaker among actors."
  },
  {
    "id": "lesser",
    "kind": "twister",
    "lang": "en",
    "text": "Lesser leather never weathered wetter weather better.",
    "phonemes": [
      "L",
      "W",
      "TH"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    }
  },
  {
    "id": "horses",
    "kind": "twister",
    "lang": "en",
    "text": "Thirty-three thirsty, thundering thoroughbreds thudded through the thicket.",
    "phonemes": [
      "TH"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    }
  },
  {
    "id": "brigadiers",
    "kind": "twister",
    "lang": "en",
    "text": "Brisk brave brigadiers brandished broad bright blades.",
    "phonemes": [
      "B",
      "R",
      "L"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    }
  },
  {
    "id": "brewery",
    "kind": "twister",
    "lang": "en",
    "text": "Rory the warrior and Roger the worrier were reared wrongly in a rural brewery.",
    "phonemes": [
      "R",
      "W"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    }
  },
  {
    "id": "skunk",
    "kind": "twister",
    "lang": "en",
    "text": "A skunk sat on a stump and thunk the stump stunk, but the stump thunk the skunk stunk.",
    "phonemes": [
      "S",
      "K",
      "N"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    }
  },
  {
    "id": "eerieear",
    "kind": "twister",
    "lang": "en",
    "text": "Near an ear, a nearer ear, a nearly eerie ear.",
    "phonemes": [
      "R"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    }
  },
  {
    "id": "thieves",
    "kind": "twister",
    "lang": "en",
    "text": "The thirty-three thieves thought that they thrilled the throne throughout Thursday.",
    "phonemes": [
      "TH"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    }
  },
  {
    "id": "sv-laxask",
    "kind": "twister",
    "lang": "sv",
    "text": "Sex laxar i en laxask.",
    "phonemes": [
      "SJ",
      "K",
      "S"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Six salmon in a salmon box."
  },
  {
    "id": "sv-kappsack",
    "kind": "twister",
    "lang": "sv",
    "text": "Packa pappas kappsäck.",
    "phonemes": [
      "P",
      "K"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Pack dad's suitcase."
  },
  {
    "id": "sv-kvastskaft",
    "kind": "twister",
    "lang": "sv",
    "text": "Kvistfritt kvastskaft.",
    "phonemes": [
      "K",
      "V",
      "S",
      "T"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Knot-free broomstick."
  },
  {
    "id": "sv-hinkar",
    "kind": "twister",
    "lang": "sv",
    "text": "Pappa hänger upp hinkar i taket.",
    "phonemes": [
      "H",
      "P"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Dad hangs buckets from the ceiling."
  },
  {
    "id": "sv-mats",
    "kind": "twister",
    "lang": "sv",
    "text": "Visst måste Mats sitta sist.",
    "phonemes": [
      "S",
      "T"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Of course Mats has to sit last."
  },
  {
    "id": "sv-vaxt",
    "kind": "twister",
    "lang": "sv",
    "text": "Typiskt västkustsk köksväxt.",
    "phonemes": [
      "K",
      "V"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Typical west-coast kitchen herb."
  },
  {
    "id": "sv-skivan",
    "kind": "twister",
    "lang": "sv",
    "text": "Klockan sju sitter en sjuk katt på skivan och sjunger.",
    "phonemes": [
      "SJ"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "At seven, a sick cat sits on the record and sings."
  },
  {
    "id": "sv-ebba",
    "kind": "twister",
    "lang": "sv",
    "text": "Ebbas pappa, pappas Ebba.",
    "phonemes": [
      "B",
      "P"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Wordplay: Ebba's dad, dad's Ebba."
  },
  {
    "id": "sv-rodrav",
    "kind": "twister",
    "lang": "sv",
    "text": "Röd räv, röd räv, röd räv.",
    "phonemes": [
      "R"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Red fox, red fox, red fox."
  },
  {
    "id": "sv-gronttroll",
    "kind": "twister",
    "lang": "sv",
    "text": "Grönt troll, grönt troll, grönt troll.",
    "phonemes": [
      "T",
      "R",
      "L"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Green troll, green troll, green troll."
  },
  {
    "id": "sv-skata",
    "kind": "twister",
    "lang": "sv",
    "text": "Snabb skata, snabb skata, snabb skata.",
    "phonemes": [
      "S",
      "K"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Fast magpie, fast magpie, fast magpie."
  },
  {
    "id": "sv-skepp",
    "kind": "twister",
    "lang": "sv",
    "text": "Sjukt skepp, sjukt skepp, sjukt skepp.",
    "phonemes": [
      "SJ",
      "S",
      "K"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Sick ship, sick ship, sick ship."
  },
  {
    "id": "sv-tjur",
    "kind": "twister",
    "lang": "sv",
    "text": "Tjock tjur, tjock tjur, tjock tjur.",
    "phonemes": [
      "TJ"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Fat bull, fat bull, fat bull."
  },
  {
    "id": "sv-vitval",
    "kind": "twister",
    "lang": "sv",
    "text": "Vit val, vit val, vit val.",
    "phonemes": [
      "V"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "White whale, white whale, white whale."
  },
  {
    "id": "sv-gragas",
    "kind": "twister",
    "lang": "sv",
    "text": "Grå gås, grå gås, grå gås.",
    "phonemes": [
      "G",
      "Å"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Grey goose, grey goose, grey goose."
  },
  {
    "id": "sv-blygbjorn",
    "kind": "twister",
    "lang": "sv",
    "text": "Blyg björn, blyg björn, blyg björn.",
    "phonemes": [
      "B"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Shy bear, shy bear, shy bear."
  },
  {
    "id": "sv-salar",
    "kind": "twister",
    "lang": "sv",
    "text": "Sju söta sälar.",
    "phonemes": [
      "S"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Seven sweet seals."
  },
  {
    "id": "sv-flugor",
    "kind": "twister",
    "lang": "sv",
    "text": "Fem fräcka flugor.",
    "phonemes": [
      "F"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Five cheeky flies."
  },
  {
    "id": "sv-tuppar",
    "kind": "twister",
    "lang": "sv",
    "text": "Tre tysta tuppar.",
    "phonemes": [
      "T"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Three quiet roosters."
  },
  {
    "id": "sv-svanar",
    "kind": "twister",
    "lang": "sv",
    "text": "Sex sömniga svanar.",
    "phonemes": [
      "S",
      "V"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Six sleepy swans."
  },
  {
    "id": "sv-nyckelpigor",
    "kind": "twister",
    "lang": "sv",
    "text": "Nio nyfikna nyckelpigor.",
    "phonemes": [
      "N"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Nine curious ladybugs."
  },
  {
    "id": "sv-fjarilar",
    "kind": "twister",
    "lang": "sv",
    "text": "Fyra fräscha fjärilar.",
    "phonemes": [
      "F"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Four fresh butterflies."
  },
  {
    "id": "sv-ankor",
    "kind": "twister",
    "lang": "sv",
    "text": "Åtta arga ankor.",
    "phonemes": [
      "Å"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Eight angry ducks."
  },
  {
    "id": "sv-krakor",
    "kind": "twister",
    "lang": "sv",
    "text": "Kalla kråkor kraxar.",
    "phonemes": [
      "K",
      "R"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Cold crows caw."
  },
  {
    "id": "sv-torskar",
    "kind": "twister",
    "lang": "sv",
    "text": "Torra torskar trivs.",
    "phonemes": [
      "T",
      "R"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Dry cods feel right at home."
  },
  {
    "id": "sv-vargar",
    "kind": "twister",
    "lang": "sv",
    "text": "Våta vargar vaktar.",
    "phonemes": [
      "V"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Wet wolves keep watch."
  },
  {
    "id": "sv-hundar",
    "kind": "twister",
    "lang": "sv",
    "text": "Hungriga hundar hoppar.",
    "phonemes": [
      "H"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Hungry dogs jump."
  },
  {
    "id": "sv-myror",
    "kind": "twister",
    "lang": "sv",
    "text": "Modiga myror marscherar.",
    "phonemes": [
      "M"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Brave ants march."
  },
  {
    "id": "sv-bjornar",
    "kind": "twister",
    "lang": "sv",
    "text": "Blöta björnar badar.",
    "phonemes": [
      "B"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Wet bears bathe."
  },
  {
    "id": "sv-skoldpaddor",
    "kind": "twister",
    "lang": "sv",
    "text": "Snabba sköldpaddor springer.",
    "phonemes": [
      "S",
      "K"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Fast turtles run."
  },
  {
    "id": "sv-getingar",
    "kind": "twister",
    "lang": "sv",
    "text": "Gula getingar surrar.",
    "phonemes": [
      "G"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Yellow wasps buzz."
  },
  {
    "id": "sv-lejon",
    "kind": "twister",
    "lang": "sv",
    "text": "Ledsna lejon ligger.",
    "phonemes": [
      "L"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Sad lions lie down."
  },
  {
    "id": "sv-krabbor",
    "kind": "twister",
    "lang": "sv",
    "text": "Krokiga krabbor kryper.",
    "phonemes": [
      "K",
      "R"
    ],
    "level": 1,
    "targetWpm": {
      "slow": 81,
      "steady": 126,
      "fast": 184
    },
    "gloss": "Crooked crabs crawl."
  },
  {
    "id": "sv-sjosjuka",
    "kind": "twister",
    "lang": "sv",
    "text": "Sju sjösjuka sjömän sköttes av sju sköna sjuksköterskor på skeppet Shanghai.",
    "phonemes": [
      "SJ"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Seven seasick sailors were nursed by seven lovely nurses on the ship Shanghai — Sweden's most famous twister."
  },
  {
    "id": "sv-droskkusken",
    "kind": "twister",
    "lang": "sv",
    "text": "Droskkusken Max kuskar med fuxar och fuskar med droskkusktaxan.",
    "phonemes": [
      "K",
      "S"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Cab driver Max drives with chestnut horses and cheats on the cab fare."
  },
  {
    "id": "sv-knut",
    "kind": "twister",
    "lang": "sv",
    "text": "Knut satt vid en knut och knöt en knut. När Knut knutit knuten var knuten knuten.",
    "phonemes": [
      "K",
      "N"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Knut sat at a corner and tied a knot. When Knut had tied the knot, the knot was tied."
  },
  {
    "id": "sv-cecilia",
    "kind": "twister",
    "lang": "sv",
    "text": "Cecilia cyklade genom centrala Cypern efter cigaretter och citroner.",
    "phonemes": [
      "S"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Cecilia biked through central Cyprus for cigarettes and lemons."
  },
  {
    "id": "sv-hanssons",
    "kind": "twister",
    "lang": "sv",
    "text": "Har herrarna här hört hur Hanssons halta höna har hickat hela hösten.",
    "phonemes": [
      "H"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Have the gentlemen here heard how Hansson's limping hen has hiccupped all autumn."
  },
  {
    "id": "sv-selma",
    "kind": "twister",
    "lang": "sv",
    "text": "Sotaren Selma samlar semlor. Se så många semlor Selma samlat.",
    "phonemes": [
      "S"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Chimney sweep Selma collects buns. See how many buns Selma has collected."
  },
  {
    "id": "sv-sag",
    "kind": "twister",
    "lang": "sv",
    "text": "Jag såg en såg och vart jag såg så såg jag bara såg vid såg.",
    "phonemes": [
      "S",
      "Å"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "I saw a saw, and wherever I looked, I only saw a saw by a saw."
  },
  {
    "id": "sv-stallet",
    "kind": "twister",
    "lang": "sv",
    "text": "Ställ stället i ställ-stället i stallet istället.",
    "phonemes": [
      "S",
      "T"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Put the rack in the rack-stand in the stable instead."
  },
  {
    "id": "sv-struts",
    "kind": "twister",
    "lang": "sv",
    "text": "En stursk struts krubbade kruska på ett kvistfritt kvastskaft.",
    "phonemes": [
      "S",
      "T",
      "R"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "A cocky ostrich munched porridge on a knot-free broomstick."
  },
  {
    "id": "sv-kallakalla",
    "kind": "twister",
    "lang": "sv",
    "text": "Dessa dagar kan man inte kalla kalla, de borde heta heta.",
    "phonemes": [
      "K"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Wordplay on kalla (call/cold) and heta (be named/hot): these days shouldn't be called 'cold' — call them 'hot'."
  },
  {
    "id": "sv-vaxadelaxar",
    "kind": "twister",
    "lang": "sv",
    "text": "Sex vaxade laxar i en vaxad laxask.",
    "phonemes": [
      "V",
      "K",
      "S"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Six waxed salmon in a waxed salmon box."
  },
  {
    "id": "sv-vaska",
    "kind": "twister",
    "lang": "sv",
    "text": "Att få en väska att växa av vätska är svårt.",
    "phonemes": [
      "V"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Getting a bag to grow from liquid is hard."
  },
  {
    "id": "sv-farfar",
    "kind": "twister",
    "lang": "sv",
    "text": "Farfar, får får får? Nej, får får inte får, får får lamm.",
    "phonemes": [
      "F",
      "R"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Grandpa, do sheep get sheep? No, sheep don't get sheep, sheep get lambs — a classic homophone twister on 'får'."
  },
  {
    "id": "sv-barbros",
    "kind": "twister",
    "lang": "sv",
    "text": "Barbros bror badade bara i Barsebäck.",
    "phonemes": [
      "B",
      "R"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Barbro's brother only bathed in Barsebäck."
  },
  {
    "id": "sv-flyg",
    "kind": "twister",
    "lang": "sv",
    "text": "Flyg, fula fluga, flyg! Och den fula flugan flög.",
    "phonemes": [
      "F",
      "L"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Fly, ugly fly, fly! And the ugly fly flew."
  },
  {
    "id": "sv-somnigasalar",
    "kind": "twister",
    "lang": "sv",
    "text": "Sju sömniga sälar simmar sakta söderut.",
    "phonemes": [
      "S"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Seven sleepy seals swim slowly southward."
  },
  {
    "id": "sv-tjejer",
    "kind": "twister",
    "lang": "sv",
    "text": "Tjugo tjatiga tjejer tjoar tyst.",
    "phonemes": [
      "TJ"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Twenty nagging girls cheer quietly."
  },
  {
    "id": "sv-kyligakaniner",
    "kind": "twister",
    "lang": "sv",
    "text": "Kyliga kaniner klättrar käckt.",
    "phonemes": [
      "K"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Chilly rabbits climb boldly."
  },
  {
    "id": "sv-gladagrodor",
    "kind": "twister",
    "lang": "sv",
    "text": "Glada grodor gömmer sig glatt i gräset.",
    "phonemes": [
      "G"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Happy frogs hide happily in the grass."
  },
  {
    "id": "sv-argaekorrar",
    "kind": "twister",
    "lang": "sv",
    "text": "Arga ekorrar äter äpplen argt.",
    "phonemes": [
      "Ä"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Angry squirrels eat apples angrily."
  },
  {
    "id": "sv-nafsar",
    "kind": "twister",
    "lang": "sv",
    "text": "Nyfikna nyckelpigor nafsar nervöst.",
    "phonemes": [
      "N"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Curious ladybugs nibble nervously."
  },
  {
    "id": "sv-rundarav",
    "kind": "twister",
    "lang": "sv",
    "text": "Runda rävar ryter rakt ut.",
    "phonemes": [
      "R"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Round foxes roar right out."
  },
  {
    "id": "sv-vitavargar",
    "kind": "twister",
    "lang": "sv",
    "text": "Vita vargar vandrar vilset.",
    "phonemes": [
      "V"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "White wolves wander lost."
  },
  {
    "id": "sv-svartasvanar",
    "kind": "twister",
    "lang": "sv",
    "text": "Svarta svanar sjunger sorgset.",
    "phonemes": [
      "S",
      "V"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Black swans sing sadly."
  },
  {
    "id": "sv-brunabjornar",
    "kind": "twister",
    "lang": "sv",
    "text": "Bruna björnar brottas bredvid bäcken.",
    "phonemes": [
      "B"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Brown bears wrestle beside the creek."
  },
  {
    "id": "sv-gulagetingar",
    "kind": "twister",
    "lang": "sv",
    "text": "Gula getingar guppar glatt i gräset.",
    "phonemes": [
      "G"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Yellow wasps bob happily in the grass."
  },
  {
    "id": "sv-hokar",
    "kind": "twister",
    "lang": "sv",
    "text": "Hungriga hökar hasar hemåt.",
    "phonemes": [
      "H"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Hungry hawks trudge homeward."
  },
  {
    "id": "sv-kvallen",
    "kind": "twister",
    "lang": "sv",
    "text": "Krokiga krabbor kryper kvickt i kvällen.",
    "phonemes": [
      "K",
      "R",
      "V"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Crooked crabs crawl quickly in the evening."
  },
  {
    "id": "sv-lagret",
    "kind": "twister",
    "lang": "sv",
    "text": "Ledsna lejon ligger lugnt i lägret.",
    "phonemes": [
      "L"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Sad lions lie calmly in the camp."
  },
  {
    "id": "sv-mullvadar",
    "kind": "twister",
    "lang": "sv",
    "text": "Modiga mullvadar möts muntert.",
    "phonemes": [
      "M"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Brave moles meet cheerfully."
  },
  {
    "id": "sv-nallar",
    "kind": "twister",
    "lang": "sv",
    "text": "Nöjda nallar knaprar nötter.",
    "phonemes": [
      "N"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Content teddy bears munch nuts."
  },
  {
    "id": "sv-tjarnen",
    "kind": "twister",
    "lang": "sv",
    "text": "Törstiga tuppar trippar tyst till tjärnen.",
    "phonemes": [
      "T",
      "TJ"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Thirsty roosters tiptoe quietly to the tarn."
  },
  {
    "id": "sv-somnigastrutsar",
    "kind": "twister",
    "lang": "sv",
    "text": "Sömniga strutsar stretar sakta.",
    "phonemes": [
      "S",
      "T"
    ],
    "level": 2,
    "targetWpm": {
      "slow": 70,
      "steady": 110,
      "fast": 160
    },
    "gloss": "Sleepy ostriches trudge slowly."
  },
  {
    "id": "sv-skonsjungande",
    "kind": "twister",
    "lang": "sv",
    "text": "Sju skönsjungande sjuksköterskor skötte sjuttiosju sjösjuka sjömän på skeppet Shanghai.",
    "phonemes": [
      "SJ"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Seven beautifully-singing nurses nursed seventy-seven seasick sailors on the ship Shanghai."
  },
  {
    "id": "sv-sjutusen",
    "kind": "twister",
    "lang": "sv",
    "text": "Sjutusen sjuhundrasjuttiosju sjösjuka sjömän sköljde sina skitiga skjortor i sjön.",
    "phonemes": [
      "SJ"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Seven thousand seven hundred seventy-seven seasick sailors rinsed their dirty shirts in the sea."
  },
  {
    "id": "sv-sjuhundra",
    "kind": "twister",
    "lang": "sv",
    "text": "Sjuhundrasjuttiosju sjuksköterskor sköter sjuhundrasjuttiosju sjösjuka sjömän.",
    "phonemes": [
      "SJ"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "777 nurses nurse 777 seasick sailors."
  },
  {
    "id": "sv-sjuskjortor",
    "kind": "twister",
    "lang": "sv",
    "text": "Sju sjösjuka sjömän på skeppet Shanghai sköljde sju skjortor i sjön.",
    "phonemes": [
      "SJ"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Seven seasick sailors on the ship Shanghai rinsed seven shirts in the sea."
  },
  {
    "id": "sv-hoo",
    "kind": "twister",
    "lang": "sv",
    "text": "Ö, ö, hö ö, hö ös mö.",
    "phonemes": [
      "Ö"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Island, island, hay-island, hay-island's bride — the classic minimalist vowel twister."
  },
  {
    "id": "sv-aoa",
    "kind": "twister",
    "lang": "sv",
    "text": "I åa ä e ö å i öa ä e å.",
    "phonemes": [
      "Å",
      "Ä"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "In the stream there's an island, and on the island there's a stream — five vowel letters, no consonants."
  },
  {
    "id": "sv-kvastskaft5",
    "kind": "twister",
    "lang": "sv",
    "text": "Kvistfritt kvastskaft. Kvistfritt kvastskaft. Kvistfritt kvastskaft. Kvistfritt kvastskaft. Kvistfritt kvastskaft.",
    "phonemes": [
      "K",
      "V",
      "S",
      "T"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Knot-free broomstick — five reps."
  },
  {
    "id": "sv-pepparkorn",
    "kind": "twister",
    "lang": "sv",
    "text": "Ett pepparkorn i en kopparpanna, två pepparkorn i en kopparpanna, tre pepparkorn i en kopparpanna.",
    "phonemes": [
      "P",
      "K"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "One peppercorn in a copper pan, two peppercorns in a copper pan, three peppercorns in a copper pan."
  },
  {
    "id": "sv-rodrav5",
    "kind": "twister",
    "lang": "sv",
    "text": "Röd räv, röd räv, röd räv, röd räv, röd räv.",
    "phonemes": [
      "R"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Red fox — five reps."
  },
  {
    "id": "sv-sjukskoterska-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Sjuk sjuksköterska skyndar skickligt till sjön för att sköta sju sjösjuka sjömän.",
    "phonemes": [
      "SJ"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "A sick nurse hurries skillfully to the sea to tend seven seasick sailors."
  },
  {
    "id": "sv-gronahonan",
    "kind": "twister",
    "lang": "sv",
    "text": "Den gröna hönan gröpte gröt i en grön gryta i går.",
    "phonemes": [
      "G",
      "R"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "The green hen scooped porridge into a green pot yesterday."
  },
  {
    "id": "sv-kallakrakor",
    "kind": "twister",
    "lang": "sv",
    "text": "Kalla kråkor kraxar klagande kring det kvistfria kvastskaftet i köket.",
    "phonemes": [
      "K",
      "R"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Cold crows caw complainingly around the knot-free broomstick in the kitchen."
  },
  {
    "id": "sv-tjugotjejer-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Tjugo tjatiga tjejer tjoade tyst tills tjänaren tystnade.",
    "phonemes": [
      "TJ"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Twenty nagging girls cheered quietly until the servant fell silent."
  },
  {
    "id": "sv-somnigasalar-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Sju sömniga sälar simmade sakta söderut medan sju svarta svanar sjöng sorgset.",
    "phonemes": [
      "S"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Seven sleepy seals swam slowly southward while seven black swans sang sadly."
  },
  {
    "id": "sv-brunabjornar-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Bruna björnar brottades bredvid den brusande bäcken i backen.",
    "phonemes": [
      "B"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Brown bears wrestled beside the rushing creek on the hill."
  },
  {
    "id": "sv-krokigakrabbor-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Krokiga krabbor kröp kvickt kring kajen när klockan klämtade.",
    "phonemes": [
      "K",
      "R"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Crooked crabs crawled quickly around the quay when the bell tolled."
  },
  {
    "id": "sv-vildavargar",
    "kind": "twister",
    "lang": "sv",
    "text": "Vilda vargar vandrade viskande vid den vindpinade vintervägen.",
    "phonemes": [
      "V"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Wild wolves wandered whispering by the windswept winter road."
  },
  {
    "id": "sv-gamlagass",
    "kind": "twister",
    "lang": "sv",
    "text": "Gamla gäss gick genom det gyllene gräset och gnisslade glatt.",
    "phonemes": [
      "G"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Old geese walked through the golden grass and squeaked happily."
  },
  {
    "id": "sv-nyfiknanallar",
    "kind": "twister",
    "lang": "sv",
    "text": "Nyfikna nallar nafsade nervöst på de nyponrosa näckrosorna.",
    "phonemes": [
      "N"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Curious teddy bears nibbled nervously at the rosehip-pink water lilies."
  },
  {
    "id": "sv-hungrigahokar-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Hungriga hökar hasade hemåt medan himlen hann bli hotfull.",
    "phonemes": [
      "H"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Hungry hawks trudged homeward while the sky managed to turn threatening."
  },
  {
    "id": "sv-modigamullvadar-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Modiga mullvadar möttes muntert mitt i den mörka mullen.",
    "phonemes": [
      "M"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Brave moles met cheerfully in the middle of the dark soil."
  },
  {
    "id": "sv-torstigatuppar-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Törstiga tuppar trippade tyst till den tjocka tjärnen och tystnade.",
    "phonemes": [
      "T",
      "TJ"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Thirsty roosters tiptoed quietly to the thick tarn and fell silent."
  },
  {
    "id": "sv-ledsnalejon-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Ledsna lejon låg lugnt i det låga lägret och lyssnade.",
    "phonemes": [
      "L"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Sad lions lay calmly in the low camp and listened."
  },
  {
    "id": "sv-snabbaskoldpaddor",
    "kind": "twister",
    "lang": "sv",
    "text": "Snabba sköldpaddor sprang skrattande genom den skuggiga skogen.",
    "phonemes": [
      "S",
      "K"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Fast turtles ran laughing through the shady forest."
  },
  {
    "id": "sv-blotabjornar-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Blöta björnar badade bredvid den brusande bäcken och busade.",
    "phonemes": [
      "B"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Wet bears bathed beside the rushing creek and fooled around."
  },
  {
    "id": "sv-argaekorrar-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Arga ekorrar åt äpplen argt medan åskan ekade över ängen.",
    "phonemes": [
      "Ä",
      "Å"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Angry squirrels ate apples angrily while thunder echoed over the meadow."
  },
  {
    "id": "sv-gladagrodor-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Glada grodor gömde sig glatt i det gröna gräset vid gården.",
    "phonemes": [
      "G"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Happy frogs hid happily in the green grass by the farm."
  },
  {
    "id": "sv-vitavargar-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Vita vargar vandrade vilset i den vita vinternatten.",
    "phonemes": [
      "V"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "White wolves wandered lost in the white winter night."
  },
  {
    "id": "sv-rundaravar-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Runda rävar rusade rakt genom den rykande röken.",
    "phonemes": [
      "R"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Round foxes rushed straight through the smoking smoke."
  },
  {
    "id": "sv-kyligakaniner-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Kyliga kaniner klättrade käckt kring den knotiga klippan i skymningen.",
    "phonemes": [
      "K"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Chilly rabbits climbed boldly around the gnarled cliff at dusk."
  },
  {
    "id": "sv-nojdanallar",
    "kind": "twister",
    "lang": "sv",
    "text": "Nöjda nallar knaprade nötter nära den nya nyckelpigan.",
    "phonemes": [
      "N"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Content teddy bears munched nuts near the new ladybug."
  },
  {
    "id": "sv-svartasvanar-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Svarta svanar sjöng sorgset medan sjuka sjöhästar simmade stilla.",
    "phonemes": [
      "S",
      "V"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Black swans sang sadly while sick seahorses swam still."
  },
  {
    "id": "sv-gulagetingar-lang",
    "kind": "twister",
    "lang": "sv",
    "text": "Gula getingar guppade glatt genom den gnistrande gryningen.",
    "phonemes": [
      "G"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Yellow wasps bobbed happily through the sparkling dawn."
  },
  {
    "id": "sv-krokodiler",
    "kind": "twister",
    "lang": "sv",
    "text": "Krokodiler kravlade kvickt kring kajen medan kråkorna kraxade konstigt.",
    "phonemes": [
      "K",
      "R"
    ],
    "level": 3,
    "targetWpm": {
      "slow": 60,
      "steady": 94,
      "fast": 136
    },
    "gloss": "Crocodiles crawled quickly around the quay while the crows cawed strangely."
  }
];
